import { render } from "./badge-transaction-category.vue?vue&type=template&id=5d3286f4"
import script from "./badge-transaction-category.vue?vue&type=script&lang=js"
export * from "./badge-transaction-category.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__